import { render, staticRenderFns } from "./NewPriceJMPopupActive.vue?vue&type=template&id=e8c3b0cc&"
import script from "./NewPriceJMPopupActive.vue?vue&type=script&lang=js&"
export * from "./NewPriceJMPopupActive.vue?vue&type=script&lang=js&"
import style0 from "./NewPriceJMPopupActive.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports